import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const _1xMobiledataIcon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"1x_mobiledata"} ref={ref}/>
});

_1xMobiledataIcon.displayName = "_1xMobiledataIcon";
